import { useContext } from "react"
import { ToastContext } from "~/context/ToastContext"

export function useToast() {
  const addToastBase = useContext(ToastContext)

  return addToastBase
}
